/*
  ALMAM - banda verticala de miniaturi din pagina de produs.

  Ce rezolva: pe ecran mare miniaturile stau intr-o banda plafonata la un numar
  fix (vezi `--pr-thumbs-visible` in CSS). Fisierul asta face doua lucruri:
  aduce in campul vizibil miniatura devenita activa, si aprinde valul de degrade
  in partea in care mai exista miniatile nevazute.

  Banda NU mai are sageti proprii (2026-08-25, cerut de clienta): rasfoirea se
  face din sagetile de peste fotografia mare, vezi `almam-product-media-nav.js`.
  Banda se deruleaza acum singura, fiindca fiecare pas al acelor sageti schimba
  miniatura activa, iar `scrollIntoBand` de mai jos o aduce la vedere.

  De ce nu se putea folosi codul temei nici pentru asta: `media-gallery.js` aduce
  miniatura activa in campul vizibil cu `scrollTo({ left: ... })`, care intr-o
  banda verticala nu misca nimic.

  De ce un fisier separat si nu o modificare in codul temei: acela se rescrie la
  orice actualizare. Aici doar ASCULT rezultatul lui - atributul `aria-current`,
  pe care il pune oricum.

  Nu face nimic cand banda nu are ce derula (produse cu putine imagini) sau cand
  layout-ul e cel de telefon, unde miniaturile stau pe orizontala si tema se
  descurca singura - de aceea totul porneste de la `isScrollable()`.
*/

(function () {
  'use strict';

  var MARGIN = 8; // spatiu lasat in jurul miniaturii aduse in vizibil

  /* Acelasi prag ca in CSS: sub el miniaturile stau pe orizontala si le
     deruleaza tema. Fara verificarea asta, o banda orizontala poate raporta
     `scrollHeight` cu un pixel peste `clientHeight` si scriptul ar crede ca are
     ce derula pe verticala - CSS-ul ascunde oricum sagetile acolo, dar cele
     doua nu trebuie sa se contrazica. */
  var vertical = window.matchMedia('(min-width: 990px)');

  function isScrollable(list) {
    return vertical.matches && list.scrollHeight > list.clientHeight + 1;
  }

  function scrollIntoBand(list, item) {
    if (!isScrollable(list)) return;

    var top = item.offsetTop;
    var bottom = top + item.offsetHeight;
    var viewTop = list.scrollTop;
    var viewBottom = viewTop + list.clientHeight;

    if (top < viewTop + MARGIN) {
      list.scrollTo({ top: Math.max(0, top - MARGIN), behavior: 'smooth' });
    } else if (bottom > viewBottom - MARGIN) {
      list.scrollTo({ top: bottom - list.clientHeight + MARGIN, behavior: 'smooth' });
    }
  }

  function connect(gallery) {
    var list = gallery.querySelector('.thumbnail-list');
    if (!list) return;

    var slider = list.closest('.thumbnail-slider') || list.parentElement;

    function refresh() {
      var scrollable = isScrollable(list);
      var max = list.scrollHeight - list.clientHeight;
      var atStart = !scrollable || list.scrollTop <= 1;
      var atEnd = !scrollable || list.scrollTop >= max - 1;

      /* Valul de degrade apare doar in partea in care chiar mai exista imagini.
         Clasele stau pe container, nu pe banda derulata: `::before` si `::after`
         trebuie sa ramana pe loc cand continutul se misca. */
      slider.classList.toggle('thumbnail-slider--more-above', !atStart);
      slider.classList.toggle('thumbnail-slider--more-below', !atEnd);
    }

    list.addEventListener('scroll', refresh, { passive: true });
    /* `scrollend` in plus fata de `scroll`: navigatorul poate uni mai multe
       derulari intr-un singur eveniment `scroll` sau il poate amana, iar atunci
       valul de degrade ar ramane la valoarea dinainte. `scrollend` se emite o
       data, cand banda s-a oprit. */
    list.addEventListener('scrollend', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    // Trecerea pragului schimba banda din orizontala in verticala si invers.
    vertical.addEventListener('change', refresh);

    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var button = records[i].target;
        if (button.getAttribute('aria-current') !== 'true') continue;
        var item = button.closest('.thumbnail-list__item');
        if (item) scrollIntoBand(list, item);
      }
    });

    observer.observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current']
    });

    /* La incarcare, miniatura activa poate fi deja in afara benzii - de exemplu
       cand se intra pe pagina cu o varianta selectata din alta pagina. */
    var current = list.querySelector('button[aria-current="true"]');
    if (current) {
      var item = current.closest('.thumbnail-list__item');
      if (item) scrollIntoBand(list, item);
    }

    refresh();

    /* Imaginile se incarca lenes, deci inaltimea benzii se poate schimba dupa
       ce scriptul a rulat; fara asta, sagetile ar ramane ascunse pe produsele
       la care banda devine derulabila abia dupa incarcarea miniaturilor. */
    if (window.ResizeObserver) {
      new ResizeObserver(refresh).observe(list);
    }
  }

  /* Aceeasi galerie nu se leaga de doua ori: in editorul de teme evenimentul de
     reincarcare poate ajunge si pentru sectiuni care nu au fost re-randate. */
  var LEGAT = 'almamThumbsLegat';

  function init(radacina) {
    (radacina || document).querySelectorAll('.product--almam media-gallery').forEach(function (gallery) {
      if (gallery.dataset[LEGAT]) return;
      gallery.dataset[LEGAT] = '1';
      connect(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* In editorul de teme, Shopify RE-RANDEAZA sectiunea la fiecare modificare:
     galeria veche dispare cu tot cu ascultatorii ei, iar cea noua ramane fara
     nimic legat - sagetile apar, dar nu fac nimic. `DOMContentLoaded` nu se mai
     emite a doua oara, deci fara asta scriptul ar parea "stricat" exact acolo
     unde se lucreaza la pagina. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
